export default function WhenNeedLawyer() {
  const situations = [
    {
      title: 'Discriminación laboral',
      description: 'Si has sido objeto de discriminación por motivos de raza, género, religión, orientación sexual u otras características protegidas por la ley, un abogado laboralista puede ayudarte a presentar una demanda o tomar acciones legales contra el empleador.'
    },
    {
      title: 'Salarios impagados o incorrectos',
      description: 'Si no has recibido el pago de tu salario completo, horas extras, comisiones u otros beneficios laborales que te corresponden, un abogado laboralista puede ayudarte a reclamar esos salarios impagados o corregir errores en los cálculos de tu remuneración.'
    },
    {
      title: 'Acoso laboral',
      description: 'Si estás siendo víctima de acoso laboral, ya sea por parte de compañeros de trabajo, superiores o incluso el empleador, un abogado laboralista puede guiarte en la presentación de una queja formal o una demanda por acoso.'
    },
    {
      title: 'Conflictos sindicales',
      description: 'Si eres miembro de un sindicato y se presenta un conflicto con el empleador, un abogado laboralista puede representar tus intereses y brindar asesoramiento sobre tus derechos sindicales y las acciones legales que puedes tomar.'
    },
    {
      title: 'Modificación de condiciones laborales',
      description: 'Si tu empleador intenta realizar cambios significativos en tu contrato de trabajo o condiciones laborales sin tu consentimiento, un laboralista puede asesorarte sobre tus derechos y las acciones legales disponibles para protegerte.'
    },
    {
      title: 'Despido injustificado',
      description: 'Si consideras que has sido despedido de manera injusta o sin causa justificada, un laboralista puede evaluar tu caso y brindarte asesoramiento legal para tomar las medidas adecuadas.'
    }
  ];

  return (
    <section className="py-20 bg-[#2C3E50]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-8">
          ¿Cuándo es necesario un laboralista?
        </h2>
        
        <p className="text-white/80 text-center mb-12 max-w-4xl mx-auto text-base leading-relaxed">
          Es necesario acudir a un abogado laboralista en diversas situaciones relacionadas con el ámbito laboral. Algunos ejemplos de cuándo es recomendable buscar la asesoría de un especialista en derecho laboral son:
        </p>

        <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {situations.map((situation, index) => (
            <div key={index} className="flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                <i className="ri-scales-3-line text-[#A77047] text-2xl"></i>
              </div>
              <div>
                <h3 className="text-[#A77047] font-bold text-base mb-2">
                  {situation.title}
                </h3>
                <p className="text-white/80 text-sm leading-relaxed">
                  {situation.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <p className="text-white/80 text-center mt-12 max-w-4xl mx-auto text-base leading-relaxed">
          Estos son solo algunos ejemplos de situaciones en las que es recomendable acudir a un especialista en derecho laboral. En general, si tienes dudas o problemas relacionados con tu empleo o tus derechos laborales, consultar a un especialista puede ser de gran ayuda para proteger tus intereses.
        </p>
      </div>
    </section>
  );
}